export const LEGAL = {
  owner: "[Ragione sociale o Nome e Cognome]",
  vat: "[Partita IVA]",
  address: "[Indirizzo sede, CAP, Città]",
  email: "[Email assistenza]",
  pec: "[PEC]",
  updated: "14 ottobre 2026",
};

const S = ({ t, children }) => (
  <section className="space-y-2">
    <h2 className="font-display font-extrabold text-xl tracking-tight">{t}</h2>
    <div className="space-y-2 text-[#333] leading-relaxed">{children}</div>
  </section>
);

const Seller = () => (
  <p>
    {LEGAL.owner}, P.IVA {LEGAL.vat}, sede in {LEGAL.address}, email {LEGAL.email}, PEC {LEGAL.pec} (di seguito "Sconto.Market" o "il Venditore").
  </p>
);

export const PAGES = {
  privacy: {
    title: "Informativa Privacy",
    body: (
      <>
        <S t="1. Titolare del trattamento"><Seller /></S>
        <S t="2. Dati raccolti">
          <p>Quando effettui un ordine raccogliamo nome e cognome, email, telefono (facoltativo) e indirizzo di consegna. Se attivi gli avvisi prezzo raccogliamo la tua email. Se lasci una recensione pubblichiamo il tuo nome con l'iniziale del cognome, il testo e l'eventuale foto.</p>
          <p>I dati della carta di pagamento sono inseriti direttamente sulla pagina sicura di Stripe e non sono mai visibili né conservati da noi.</p>
        </S>
        <S t="3. Finalità e basi giuridiche">
          <p>a) Gestire e consegnare l'ordine, assistenza e comunicazioni sullo stato dell'ordine (esecuzione del contratto, art. 6.1.b GDPR); b) adempiere obblighi fiscali e contabili (obbligo di legge, art. 6.1.c); c) inviarti gli avvisi di calo prezzo che hai richiesto (consenso, art. 6.1.a, revocabile in ogni momento dal link presente in ogni email); d) prevenire frodi e tutelare i nostri diritti (legittimo interesse, art. 6.1.f).</p>
        </S>
        <S t="4. Destinatari">
          <p>I dati sono condivisi solo con i fornitori necessari al servizio, nominati responsabili del trattamento: Stripe (pagamenti), il fornitore che spedisce il prodotto direttamente al tuo indirizzo (ad esempio Amazon e i suoi corrieri), il servizio di invio email e il fornitore di hosting. Alcuni fornitori possono trattare dati fuori dall'UE con garanzie adeguate (clausole contrattuali standard).</p>
        </S>
        <S t="5. Conservazione">
          <p>Dati degli ordini: 10 anni per obblighi fiscali. Email per avvisi prezzo: fino alla disiscrizione. Recensioni: fino a richiesta di cancellazione.</p>
        </S>
        <S t="6. I tuoi diritti">
          <p>Puoi chiedere accesso, rettifica, cancellazione, limitazione, portabilità e opporti al trattamento scrivendo a {LEGAL.email}. Hai diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).</p>
        </S>
      </>
    ),
  },
  cookie: {
    title: "Cookie Policy",
    body: (
      <>
        <S t="1. Cosa usiamo">
          <p>Questo sito usa solo strumenti tecnici necessari al funzionamento: la memoria locale del browser per ricordare carrello e lista desideri, e cookie tecnici di sessione per l'accesso all'area riservata. Non usiamo cookie di profilazione, pubblicitari o di analisi di terze parti.</p>
        </S>
        <S t="2. Consenso">
          <p>Per gli strumenti tecnici non è richiesto il consenso (art. 122 Codice Privacy e Linee guida del Garante del 10 giugno 2021). Se in futuro introdurremo cookie non tecnici ti chiederemo prima il consenso con un apposito banner.</p>
        </S>
        <S t="3. Pagamento">
          <p>Al momento del pagamento vieni reindirizzato sul sito di Stripe, che può usare propri cookie tecnici e antifrode secondo la propria informativa (stripe.com/it/privacy).</p>
        </S>
        <S t="4. Come gestirli">
          <p>Puoi cancellare cookie e memoria locale dalle impostazioni del tuo browser; in tal caso carrello e preferiti verranno svuotati.</p>
        </S>
      </>
    ),
  },
  "condizioni-vendita": {
    title: "Condizioni Generali di Vendita",
    body: (
      <>
        <S t="1. Venditore"><Seller /><p>Le presenti condizioni regolano gli acquisti su scontomarket.it da parte di consumatori ai sensi del Codice del Consumo (D.Lgs. 206/2005).</p></S>
        <S t="2. Prodotti e prezzi">
          <p>I prezzi sono in euro, IVA inclusa. La spedizione in Italia è gratuita. Le foto hanno valore illustrativo: fanno fede titolo e descrizione. Il prezzo applicato è quello visualizzato al momento dell'ordine.</p>
        </S>
        <S t="3. Ordine e conclusione del contratto">
          <p>Il contratto si conclude quando ricevi l'email di conferma dopo il pagamento. Se un prodotto risultasse non più disponibile presso il fornitore, ti avviseremo e rimborseremo integralmente l'importo entro 14 giorni.</p>
        </S>
        <S t="4. Pagamento">
          <p>Il pagamento avviene con carta di credito/debito, Apple Pay o Google Pay tramite Stripe. L'importo è addebitato al momento dell'ordine.</p>
        </S>
        <S t="5. Spedizione e consegna">
          <p>I prodotti sono spediti direttamente dal nostro fornitore (ad esempio Amazon) al tuo indirizzo, anche in confezioni con il marchio del fornitore. Tempi indicativi: 2-5 giorni lavorativi. Riceverai via email il numero di tracking quando disponibile. Il rischio passa a te alla consegna.</p>
        </S>
        <S t="6. Diritto di recesso">
          <p>Hai 14 giorni dalla consegna per recedere senza motivazione. Tutti i dettagli sono nella pagina <a href="/recesso" className="underline">Diritto di recesso</a>.</p>
        </S>
        <S t="7. Garanzia legale di conformità">
          <p>Tutti i prodotti sono coperti dalla garanzia legale di 24 mesi dalla consegna per i difetti di conformità (artt. 128 e ss. Codice del Consumo). Per attivarla scrivi a {LEGAL.email} descrivendo il difetto.</p>
        </S>
        <S t="8. Reclami e legge applicabile">
          <p>Per reclami scrivi a {LEGAL.email}: rispondiamo entro 7 giorni lavorativi. Il contratto è regolato dalla legge italiana; per le controversie è competente il foro del luogo di residenza del consumatore.</p>
        </S>
      </>
    ),
  },
  recesso: {
    title: "Diritto di Recesso e Resi",
    body: (
      <>
        <S t="1. Termine">
          <p>Puoi recedere dal contratto entro 14 giorni dalla consegna del prodotto, senza dover fornire motivazioni (artt. 52 e ss. Codice del Consumo).</p>
        </S>
        <S t="2. Come esercitarlo">
          <p>Invia una comunicazione chiara a {LEGAL.email} indicando il codice ordine (es. MK-XXXXXXXX), il prodotto da restituire e i tuoi dati. Puoi usare il modulo qui sotto, ma non è obbligatorio. Ti risponderemo con le istruzioni e l'indirizzo per la restituzione.</p>
        </S>
        <S t="3. Restituzione del prodotto">
          <p>Il prodotto va restituito entro 14 giorni dalla comunicazione di recesso, integro e con la confezione originale. Le spese di restituzione sono a carico del cliente, salvo prodotto difettoso o non conforme.</p>
        </S>
        <S t="4. Rimborso">
          <p>Rimborsiamo l'intero importo pagato, con lo stesso metodo di pagamento, entro 14 giorni dalla ricezione della comunicazione di recesso. Possiamo trattenere il rimborso finché non riceviamo il prodotto o la prova della spedizione.</p>
        </S>
        <S t="5. Esclusioni">
          <p>Il recesso è escluso per prodotti sigillati aperti che non si prestano a essere restituiti per motivi igienici (es. spazzolini, articoli per la cura personale), per prodotti personalizzati e per contenuti digitali già attivati (art. 59 Codice del Consumo).</p>
        </S>
        <S t="Modulo di recesso (facoltativo)">
          <p className="font-mono text-sm bg-white border border-[#0F0F0F] p-4 whitespace-pre-line">{`Destinatario: ${LEGAL.owner}, ${LEGAL.address}, ${LEGAL.email}
Con la presente notifico il recesso dal mio contratto di vendita relativo al seguente bene: ______
Codice ordine: ______   Ricevuto il: ______
Nome e cognome: ______
Indirizzo: ______
Data: ______`}</p>
        </S>
      </>
    ),
  },
};
